(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
this.headerIsAlwaysSticky = ['always', 'reduce-logo-size'].includes(
  this.getAttribute('data-sticky-type')
);
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wjd-detour')) {
    customElements.define('wjd-detour', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => this.initialize());
      }

      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
      }

      initialize() {
        if (!this.isConnected || this.events) return;
        const config = this.querySelector('[data-detour-config]');
        if (!config) return;
        try { this.copy = JSON.parse(config.textContent); } catch { return; }
        for (const [key, value] of Object.entries(this.copy)) {
          this.copy[key] = Array.isArray(value) ? value.map(text => this.plainText(text)) : this.plainText(value);
        }
        if (!Array.isArray(this.copy.fortunes) || !this.copy.fortunes.length) return;
        this.events = new AbortController();
        this.index = this.index || 0;
        this.card = this.querySelector('[data-fortune-button]');
        this.fortune = this.querySelector('[data-fortune]');
        this.status = this.querySelector('[data-status]');
        const options = { signal: this.events.signal };
        this.card.addEventListener('click', () => this.nextFortune(), options);
        this.querySelector('[data-save]').addEventListener('click', (event) => this.exportCard(event.currentTarget, false), options);
        this.querySelector('[data-share]').addEventListener('click', (event) => this.exportCard(event.currentTarget, true), options);
        this.querySelector('[data-keepsake]').hidden = false;
      }

      plainText(value) {
        const entities = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", '#39': "'", '#x27': "'" };
        return String(value).replace(/&(amp|lt|gt|quot|apos|#39|#x27);/gi, (entity, key) => entities[key.toLowerCase()]);
      }

      nextFortune() {
        this.index = (this.index + 1) % this.copy.fortunes.length;
        this.fortune.textContent = this.copy.fortunes[this.index];
        this.status.textContent = '';
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches && this.fortune.animate) {
          this.fortune.animate([{ opacity: .35, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 240, easing: 'ease-out' });
        }
      }

      drawCard() {
        const canvas = document.createElement('canvas');
        canvas.width = 1200;
        canvas.height = 1440;
        const ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('Canvas unavailable');
        ctx.fillStyle = '#f4efe3';
        ctx.fillRect(0, 0, 1200, 1440);
        ctx.strokeStyle = '#cec5ad';
        ctx.lineWidth = 2;
        ctx.strokeRect(35, 35, 1130, 1370);
        ctx.fillStyle = '#61664f';
        ctx.textAlign = 'left';
        ctx.font = '500 24px Arial, sans-serif';
        ctx.fillText(this.copy.kicker, 85, 120);
        ctx.textAlign = 'right';
        ctx.fillText(this.copy.number, 1115, 120);
        ctx.textAlign = 'center';
        ctx.fillStyle = '#252920';
        ctx.font = '400 390px Georgia, serif';
        ctx.fillText('4', 303, 568);
        ctx.fillText('4', 895, 568);
        ctx.save();
        ctx.translate(600, 430);
        ctx.rotate(16 * Math.PI / 180);
        const gold = ctx.createLinearGradient(-130, -170, 130, 170);
        gold.addColorStop(0, '#a87c34');
        gold.addColorStop(.3, '#ecd6a4');
        gold.addColorStop(.55, '#b7883c');
        gold.addColorStop(.8, '#f0dbab');
        gold.addColorStop(1, '#aa7a31');
        ctx.strokeStyle = gold;
        ctx.lineWidth = 28;
        ctx.beginPath();
        ctx.ellipse(0, 0, 107, 155, 0, 0, Math.PI * 2);
        ctx.stroke();
        ctx.strokeStyle = '#f8e9c5';
        ctx.lineWidth = 2;
        ctx.stroke();
        ctx.restore();
        ctx.fillStyle = '#252920';
        let size = 92;
        const lines = this.copy.fortunes[this.index].split('\n');
        while (size > 36) {
          ctx.font = '400 ' + size + 'px Georgia, serif';
          if (lines.every(line => ctx.measureText(line).width <= 1020)) break;
          size -= 2;
        }
        const lineHeight = size * 1.2;
        lines.forEach((line, index) => ctx.fillText(line, 600, 760 + index * lineHeight));
        ctx.font = '400 140px Arial, sans-serif';
        ctx.fillText('wjd', 600, 1140);
        ctx.fillStyle = '#61664f';
        ctx.font = '500 21px Arial, sans-serif';
        ctx.fillText(this.copy.footer, 600, 1200);
        ctx.font = '400 23px Arial, sans-serif';
        ctx.fillText(new URL(this.dataset.shareUrl).hostname, 600, 1320);
        return canvas;
      }

      download(file) {
        const url = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.download = file.name;
        document.body.append(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 10000);
      }

      async exportCard(button, share) {
        if (this.busy) return;
        this.busy = true;
        button.disabled = true;
        this.status.textContent = '';
        try {
          const canvas = this.drawCard();
          const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
          if (!blob) throw new Error('Image unavailable');
          const file = new File([blob], 'wjd-detour-card.png', { type: 'image/png' });
          if (share && navigator.share && navigator.canShare?.({ files: [file] })) {
            await navigator.share({ files: [file], title: this.copy.kicker, text: this.copy.shareText });
            this.status.textContent = this.copy.shared;
          } else if (share && navigator.share) {
            await navigator.share({ title: this.copy.kicker, text: this.copy.shareText, url: this.dataset.shareUrl });
            this.status.textContent = this.copy.shared;
          } else {
            this.download(file);
            this.status.textContent = this.copy.saved;
          }
        } catch (error) {
          if (error.name !== 'AbortError') this.status.textContent = this.copy.error;
        } finally {
          this.busy = false;
          button.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
function initializeWjdGuides(){document.querySelectorAll('[data-wjd-guide]').forEach(guide=>{if(guide.dataset.guideReady)return;guide.dataset.guideReady='true';const contents=guide.querySelector('[data-guide-contents]');const body=guide.querySelector('.article-template__content');if(!contents||!body)return;const headings=[...body.querySelectorAll('h2')].filter(h=>h.textContent.trim());if(headings.length<3)return;const list=contents.querySelector('ol');headings.forEach((heading,index)=>{if(!heading.id){let id='wjd-guide-part-'+(index+1);while(document.getElementById(id))id+='-section';heading.id=id;}const item=document.createElement('li');const anchor=document.createElement('a');anchor.href='#'+encodeURIComponent(heading.id);anchor.textContent=heading.textContent.trim();item.append(anchor);list.append(item);});contents.hidden=false;});}initializeWjdGuides();document.addEventListener('shopify:section:load',initializeWjdGuides);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"]) return;
  try {
    
if(!customElements.get('wjd-fit-guide')){
customElements.define('wjd-fit-guide',class extends HTMLElement{
 connectedCallback(){
  if(this.initialized)return;
  this.initialized=true;
  this.addEventListener('click',event=>{
   const unit=event.target.closest('[data-unit]');
   if(unit&&unit.tagName==='BUTTON'){
    this.dataset.unit=unit.dataset.unit;
    this.querySelectorAll('button[data-unit]').forEach(button=>button.setAttribute('aria-pressed',String(button===unit)));
   }
   const summary=event.target.closest('summary');
   if(!summary||summary.parentElement!==this.querySelector('details')||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
   event.preventDefault();
   const details=summary.parentElement;
   const opening=this.motion?!this.motion.opening:!details.open;
   const start=details.getBoundingClientRect().height;
   if(this.motion)this.motion.animation.cancel();
   details.open=false;
   const closed=details.getBoundingClientRect().height;
   details.open=true;
   const end=opening?details.getBoundingClientRect().height:closed;
   details.style.overflow='hidden';
   const animation=details.animate([{height:start+'px'},{height:end+'px'}],{duration:300,easing:'cubic-bezier(.22,1,.36,1)'});
   this.motion={animation,opening};
   animation.onfinish=()=>{details.open=opening;details.style.overflow='';this.motion=null;};
  });
  const info=document.querySelector('product-info .product__info-container');
  const place=()=>{
   const card=info?.querySelector('.wjd-about-card');
   if(card&&!card.contains(this))card.append(this);
  };
  place();
  if(info){this.observer=new MutationObserver(place);this.observer.observe(info,{childList:true,subtree:true});}
 }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wjd-service-strip"]) return;
  try {
    
if (!customElements.get('wjd-service-strip')) {
  customElements.define('wjd-service-strip',class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events=new AbortController();
      const signal=this.events.signal;
      this.mobile=matchMedia('(max-width:989px)');
      this.reduced=matchMedia('(prefers-reduced-motion:reduce)');
      this.panel=this.querySelector('.wjd-service-panel');this.button=this.querySelector('[data-wjd-service-open]');
      this.label=this.querySelector('[data-wjd-service-current]');
      this.reviews=this.querySelector('.wjd-service-reviews');
      this.chatButton=this.querySelector('[data-wjd-service-chat]');
      this.chatStatus=this.querySelector('[data-wjd-service-chat-status]');
      this.chatButton.addEventListener('click',()=>this.openChat(),{signal});
      this.messages=[...this.querySelectorAll('[data-wjd-service-label]')].map(link=>link.textContent.trim());
      this.index=1;this.inView=true;this.expanded=false;
      this.button.addEventListener('click',event=>{
        if(this.swiped){event.preventDefault();this.swiped=false;return;}
        this.toggle(!this.expanded);
      },{signal});
      this.button.addEventListener('pointerdown',event=>{
        this.swiped=false;
        if(event.pointerType==='mouse')return;
        this.touch={x:event.clientX,y:event.clientY,id:event.pointerId};
        this.stop();
        try{this.button.setPointerCapture(event.pointerId);}catch{}
      },{signal,passive:true});
      this.button.addEventListener('pointerup',event=>{
        const start=this.touch;this.touch=null;
        if(!start || start.id!==event.pointerId)return;
        const x=event.clientX-start.x,y=event.clientY-start.y;
        if(Math.abs(x)>=32 && Math.abs(x)>Math.abs(y)*1.5){this.swiped=true;event.preventDefault();this.rotate(x<0?1:-1,true);}
        else this.schedule();
      },{signal});
      this.button.addEventListener('pointercancel',()=>{this.touch=null;this.swiped=false;this.schedule();},{signal});
      this.querySelectorAll('[data-wjd-service-close]').forEach(button=>button.addEventListener('click',()=>this.toggle(false,true),{signal}));
      document.addEventListener('click',event=>{
        if(this.expanded && !event.composedPath().includes(this))this.toggle(false);
      },{signal});
      window.addEventListener('scroll',()=>{
        if(!this.expanded || this.scrollFrame)return;
        this.scrollFrame=requestAnimationFrame(()=>{
          this.scrollFrame=null;
          if(this.expanded && scrollY-this.openedAt>=18)this.toggle(false);
        });
      },{signal,passive:true});
      this.addEventListener('keydown',event=>{
        if(event.key==='Escape' && this.expanded){event.preventDefault();event.stopPropagation();this.toggle(false,true);}
      },{signal});
      document.addEventListener('visibilitychange',()=>this.schedule(),{signal});
      this.mobile.addEventListener('change',()=>{if(!this.mobile.matches)this.toggle(false);this.schedule();},{signal});
      this.reduced.addEventListener('change',()=>{this.panelMotion?.cancel();this.panelMotion=null;this.panel.hidden=!this.expanded;this.releasePosition();this.schedule();},{signal});
      this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){this.hovered=true;this.stop();}},{signal});
      this.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse'){this.hovered=false;this.schedule();}},{signal});
      this.addEventListener('focusin',()=>{if(document.documentElement.dataset.wjdInput!=='pointer')this.stop();},{signal});
      this.addEventListener('focusout',()=>this.schedule(),{signal});
      if('IntersectionObserver' in window){
        this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.schedule();});
        this.observer.observe(this.button);
      }
      this.schedule();
    }
    toggle(open,restoreFocus=false) {
      if(open===this.expanded)return;
      if(open && this.reviews)this.reviews.open=false;
      if(!open)this.cancelChat();
      const height=this.panel.hidden?0:this.panel.getBoundingClientRect().height;
      const opacity=this.panel.hidden?0:Number(getComputedStyle(this.panel).opacity);
      const preserve=!open && this.getBoundingClientRect().bottom<=0;
      this.stop();this.panelMotion?.cancel();this.panelMotion=null;
      this.releasePosition();
      if(preserve)this.holdPosition();
      if(open)this.openedAt=scrollY;
      this.expanded=open;this.button.setAttribute('aria-expanded',String(open));
      this.querySelector('.wjd-service-heading').setAttribute('aria-expanded',String(open));
      this.panel.inert=!open;this.panel.hidden=false;
      const finish=()=>{this.panel.hidden=!this.expanded;this.panelMotion=null;this.releasePosition();if(!this.expanded && restoreFocus)this.button.focus({preventScroll:true});};
      if(this.reduced.matches || !this.mobile.matches)finish();
      else{
        const target=open?this.panel.scrollHeight:0;
        const duration=open?Math.max(160,380*Math.min(1,Math.abs(target-height)/Math.max(this.panel.scrollHeight,1))):380;
        const motion=this.panel.animate([{height:height+'px',opacity},{height:target+'px',opacity:open?1:0}],{duration,easing:'cubic-bezier(.4,0,.2,1)'});
        this.panelMotion=motion;motion.finished.then(()=>{if(this.panelMotion===motion)finish();},()=>{});
      }
      if(open && document.documentElement.dataset.wjdInput!=='pointer')this.panel.querySelector('[data-wjd-service-close]')?.focus({preventScroll:true});
      if(!open)this.schedule();
    }
    holdPosition() {
      const anchor=document.getElementById('MainContent');
      if(!anchor || anchor.getBoundingClientRect().top>=innerHeight)return;
      const root=document.documentElement;
      this.position={anchor,top:anchor.getBoundingClientRect().top,y:scrollY,value:root.style.getPropertyValue('overflow-anchor'),priority:root.style.getPropertyPriority('overflow-anchor')};
      root.style.setProperty('overflow-anchor','none');
      const tick=()=>{this.correctPosition();if(this.position)this.positionFrame=requestAnimationFrame(tick);};
      this.positionFrame=requestAnimationFrame(tick);
    }
    correctPosition() {
      const state=this.position;
      if(!state)return;
      const shift=state.anchor.getBoundingClientRect().top-state.top+scrollY-state.y;
      if(Math.abs(shift)>.5)window.scrollBy({top:shift,behavior:'instant'});
      state.top=state.anchor.getBoundingClientRect().top;state.y=scrollY;
    }
    releasePosition() {
      if(this.positionFrame)cancelAnimationFrame(this.positionFrame);
      this.positionFrame=null;
      if(!this.position)return;
      this.correctPosition();
      const {value,priority}=this.position;this.position=null;
      if(value)document.documentElement.style.setProperty('overflow-anchor',value,priority);
      else document.documentElement.style.removeProperty('overflow-anchor');
    }
    schedule() {
      this.stop();
      const keyboardFocus=this.contains(document.activeElement) && document.documentElement.dataset.wjdInput!=='pointer';
      if(!this.isConnected || !this.mobile.matches || this.reduced.matches || document.hidden || !this.inView || this.expanded || this.touch || this.hovered || keyboardFocus)return;
      this.timer=setTimeout(()=>this.rotate(),6000);
    }
    rotate(step=1,manual=false) {
      if(!this.isConnected || document.hidden || this.expanded || !this.mobile.matches || !this.inView || !this.messages.length || (this.reduced.matches && !manual))return;
      this.stop();
      const previous=this.label.textContent;
      this.index=(this.index+step+this.messages.length)%this.messages.length;
      this.label.textContent=this.messages[this.index];
      this.schedule();
      if(this.reduced.matches)return;
      const outgoing=this.label.cloneNode(true);outgoing.removeAttribute('data-wjd-service-current');outgoing.textContent=previous;this.label.after(outgoing);this.outgoing=outgoing;
      const direction=step<0?-1:1;
      this.outMotion=outgoing.animate([{opacity:1,transform:'translateX(0)'},{opacity:0,transform:'translateX('+(-direction*36)+'px)'}],{duration:340,easing:'cubic-bezier(.22,.61,.36,1)'});
      this.motion=this.label.animate([{opacity:0,transform:'translateX('+(direction*36)+'px)'},{opacity:1,transform:'translateX(0)'}],{duration:340,easing:'cubic-bezier(.22,.61,.36,1)'});
      const motion=this.motion;
      motion.finished.then(()=>{if(this.motion===motion){this.motion=null;this.outMotion?.cancel();this.outMotion=null;this.outgoing?.remove();this.outgoing=null;}},()=>{});
    }
    cancelChat() {
      clearTimeout(this.chatTimer);
      this.chatGeneration=(this.chatGeneration||0)+1;
      this.chatButton?.removeAttribute('aria-busy');
      if(this.chatStatus)this.chatStatus.hidden=true;
    }
    chatLauncher() {
      const chat=document.querySelector('shopify-chat');
      const runtime=chat?.shadowRoot?.querySelector('shopify-agent-runtime');
      return runtime?.shadowRoot?.querySelector('button[part~="activator"]')
        || chat?.shadowRoot?.querySelector('button[part~="activator"]')
        || document.querySelector('inbox-online-store-chat')?.shadowRoot?.querySelector('button');
    }
    openChat() {
      if(this.chatButton.getAttribute('aria-busy')==='true')return;
      this.cancelChat();
      this.chatButton.removeAttribute('data-chat-unavailable');
      this.chatButton.setAttribute('aria-busy','true');
      this.chatStatus.textContent=this.dataset.chatLoading;
      this.chatStatus.hidden=false;
      const chatSource='https://cdn.shopify.com/storefront/web-components/chat.js';
      const deferred=[...document.querySelectorAll('script[data-src]')].find(script=>script.getAttribute('data-src')===chatSource);
      if(deferred && !document.querySelector('script[src="'+chatSource+'"]')){
        const script=deferred.cloneNode(false);
        script.type='module';script.src=chatSource;script.async=true;
        script.removeAttribute('data-src');deferred.removeAttribute('data-src');deferred.replaceWith(script);
      }
      const generation=this.chatGeneration,started=Date.now();
      const attempt=()=>{
        if(generation!==this.chatGeneration || !this.isConnected || !this.expanded)return;
        const launcher=this.chatLauncher();
        if(launcher){
          this.toggle(false);
          if(typeof window.openChat==='function')window.openChat();
          else if(launcher.getAttribute('aria-expanded')!=='true')launcher.click();
          return;
        }
        if(Date.now()-started>=8000){
          this.chatButton.removeAttribute('aria-busy');
          this.chatButton.setAttribute('data-chat-unavailable','');
          this.chatStatus.textContent=this.dataset.chatError;
          return;
        }
        this.chatTimer=setTimeout(attempt,300);
      };
      attempt();
    }
    stop(){clearTimeout(this.timer);this.motion?.cancel();this.motion=null;this.outMotion?.cancel();this.outMotion=null;this.outgoing?.remove();this.outgoing=null;}
    disconnectedCallback(){this.cancelChat();this.stop();this.panelMotion?.cancel();this.panelMotion=null;this.releasePosition();if(this.scrollFrame)cancelAnimationFrame(this.scrollFrame);this.scrollFrame=null;this.observer?.disconnect();this.events?.abort();this.events=null;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
